module.exports = __webpack_public_path__ + "static/img/c4-4.a21cb5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/c4-4.png
// module id = 881
// module chunks = 1